import { RefNumber, RefString } from "@tblabs/truffle";


export class BitcoinPriceProvider
{
    public BtcValueInPln = new RefNumber(0).Storable("bitcoin-price");
    public Status = new RefString();

    public async Update(): Promise<void>
    {
        const urlAPI = "https://blockchain.info/ticker";

        try
        {
            this.Status.value = "🚀";
            const response = await fetch(urlAPI);

            if (!response.ok)
            {
                this.Status.value = "💔";
                return;
            }

            const data = await response.json();

            if (data.PLN)
            {
                const btcInPln = data.PLN.last;
                this.BtcValueInPln.value = btcInPln;
                this.Status.value = "✅";
            }
            else
            {
                this.Status.value = "💔";
                console.error("Nie udało się uzyskać danych kursu BTC w PLN.");
            }
        }
        catch (error)
        {
            this.Status.value = "💔";
            console.error("Błąd podczas pobierania danych z API:", error);
        }
    }

    public PLNtoBTC(amount: number): string
    {
        return (amount / this.BtcValueInPln.value).toFixed(6);
    }
}
